// extracted by mini-css-extract-plugin
export default {"mainLay":"MainLayout_mainLay__tIHkz","page":"MainLayout_page__GjT1W"};